// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__7RyEt","navbarLogo":"Navbar_navbarLogo__8ArU3","navbarLogoDesktop":"Navbar_navbarLogoDesktop__ydnwV","navbarLogoMobile":"Navbar_navbarLogoMobile__gQDQR"};